import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services';
import { routes } from '../../../../consts';

@Component({
  selector: 'app-auth-page',
  templateUrl: './auth-page.component.html',
  styleUrls: ['./auth-page.component.scss']
})
export class AuthPageComponent {
  public todayDate: Date = new Date();
  public routers: typeof routes = routes;

  constructor(
    private service: AuthService,
    private router: Router
  ) { }

  public sendLoginForm(): void {
    
    
    let role = localStorage.getItem('role');
    
    if(role == "SA" || role == "CA" || role == "CV"){
      this.router.navigate([this.routers.DASHBOARD]);
    }
    if(role == "C"){
      this.router.navigate([this.routers.CUSTOMER]);
    }
  }

  public sendSignForm(): void {
    this.service.sign();

    this.router.navigate([this.routers.DASHBOARD]).then();
  }
}
